export default __webpack_public_path__ + "static/media/la-energia-solar.714c0405.jpg";